import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { NavLink as Link } from 'react-router-dom';
import { Flex } from 'rebass/styled-components';
import {
  space, fontSize, fontWeight,
} from 'styled-system';
import theme from 'styled-theming';
import { NewTag } from '.';
import { showNewTag } from '../services';
import { useAppState } from '../hooks';

const linkColor = theme.variants('mode', 'mode', {
  active: {
    light: (props) => props.theme.colors.black,
    dark: (props) => props.theme.colors.white,
  },
  inactive: {
    light: (props) => props.theme.colors.grey,
    dark: (props) => props.theme.lpColorsDark.graya9,
  },
});

const linkHoverColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.superLightPurple,
  dark: (props) => props.theme.colors.ghostBlack,
});

const backgroundHoverColor = theme('mode', {
  light: (props) => props.theme.colors.superLightPurple,
  dark: (props) => props.theme.colors.ghostBlack,
});

const NavLinkItem = styled(Link)`
  transition: ${(props) => props.theme.animation.normal};
  ${space}
  ${fontSize}
  ${fontWeight}
  border-radius: ${(props) => props.theme.radius.small};
  color: ${linkColor};
  background-color: ${(props) => (
    props.to !== undefined && props.to === props.path ? backgroundColor : 'transparent'
  )};
  text-decoration: none;
  &:hover {
    color: ${linkHoverColor};
    background-color: ${backgroundHoverColor};
  }
`;

function NavLink(props) {
  const {
    to, label, path, ...otherProps
  } = props;
  const { features, isCcsV2 } = useAppState();

  return (
    <NavLinkItem
      data-testid="nav-link"
      py="6px"
      pl={2}
      ml={24}
      pr={2}
      fontSize={1}
      fontWeight={300}
      to={to}
      path={path}
      mode={(to !== undefined && to === path) ? 'active' : 'inactive'}
      {...otherProps}
    >
      <Flex justifyContent="space-between">
        {label}
        {showNewTag(to, features, { isCcsV2 }) ? <NewTag testId={to.slice(1)} /> : null}
      </Flex>
    </NavLinkItem>
  );
}

NavLink.defaultProps = {
  to: '',
  path: '',
  label: undefined,
};

NavLink.propTypes = {
  to: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
};

export default NavLink;
